import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={20.666}
    height={25.989}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 12180 15317"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:169.742}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974342741552">
        <path
          d="M2600 6032c0 199 34 483 67 672 127 741 380 1033 714 1593 389 649 720 1465 787 2261 393-91 861-59 1272-59l-91-1419c-35-454-79-967-116-1421-440 0-640 11-928-167-554-343-570-1318 134-1633 596-267 1192 112 1310 662 20 91 46 425 46 516h591c30-349 36-786 337-1024 671-528 1557-151 1557 758 0 267-154 518-304 643-328 274-606 245-1028 245 0 256-11 458-31 708-40 515-146 1679-146 2132 594 0 692 11 1272 59 0-314 178-930 271-1179 137-368 292-654 469-981 518-956 798-1210 798-2455 0-470-173-1029-334-1352-125-249-304-551-486-756-72-80-145-144-222-222-865-865-2060-1201-3270-917-1288 302-2242 1318-2563 2584-29 112-57 246-69 345-15 122-37 307-37 407zM3872 13162c0 291 212 503 503 503h3432c655 0 700-977-60-977H4434c-176 0-284 35-379 125-89 82-183 187-183 349zM3872 11564c0 338 228 532 562 532h3313c745 0 726-976 60-976H4375c-128 0-278 63-349 125-59 52-154 218-154 319zM6002 15232c307 0 522-31 763-272 177-177 272-391 272-674H5144c0 299 96 485 243 644 122 131 377 302 615 302zM85 6091c0 439 722 325 1154 325 117 0 215-16 291-64 285-179 129-587-143-587H381c-169 0-296 156-296 326zM10499 6091c0 439 723 325 1154 325 637 0 494-651 148-651h-1006c-169 0-296 156-296 326zM9878 8369c0 382 145 344 689 671 91 55 306 189 416 205 324 46 498-419 174-617-128-79-797-496-924-496-205 0-355 114-355 237zM2925 1150c0 152 366 731 493 957 197 352 631 193 631-128 0-133-366-718-445-857-321-566-679-179-679 28zM8132 1949c0 390 439 479 621 177 59-98 108-196 169-305 96-173 334-497 334-671 0-216-363-575-668-47-70 121-456 763-456 846zM854 3221c0 253 97 263 297 383 131 78 253 152 394 228 100 55 303 190 414 206 267 38 345-189 345-403 0-175-551-428-771-560-160-97-194-150-383-150-166 0-296 130-296 296zM854 8901c0 235 152 355 322 346 149-7 648-336 812-424 293-159 316-178 316-454 0-122-237-343-511-185l-750 433c-103 59-189 136-189 284zM5765 440v917c0 408 651 408 651 0V440c0-214-130-332-274-355h-103c-144 23-274 141-274 355zM9878 3635c0 209 61 419 321 405 135-7 655-339 813-424 292-159 315-177 315-454 0-122-237-343-510-185l-712 412c-86 46-227 143-227 246z"
          className="fil0"
        />
        <path
          d="m6061 10529 178-1420c9-202 54-507 59-710 5-205 20-572 59-740h-533c55 236 112 1781 165 2143 18 119 13 235 29 355 16 107 41 286 43 372zM4818 7037h326c0-251 65-650-326-650-408 0-408 650 0 650zM7037 6682v355c226 0 610 58 638-303 34-435-638-454-638-52z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
